<template>
  <div>
    <div class="air__utils__heading">
      <div class="row align-items-center">
        <div class="col-md-4 col-sm-6">
          <h5>Tuition Sessions</h5>
        </div>
        <div class="col-md-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row align-items-center w-100 justify-content-end">
            <span class="mr-3 font-weight-bold">Select Program:</span>
            <a-select
              show-search
              placeholder="Select a tuition program"
              style="width: 250px"
              class="mr-4 text-left"
              :options="programOptions"
              v-model="selectedProgramId"
              @change="fetchSessions"
              :loading="loadingPrograms"
              :filter-option="filterProgramOption"
            />

            <div class="mr-2">
              <add-session-modal
                :programId="selectedProgramId"
                @created="fetchSessions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div v-if="!selectedProgramId" class="text-center py-5">
              <a-empty description="Please select a tuition program to view its sessions" />
            </div>
            <tuition-session-table
              v-else
              :data="data"
              :loading="loadingSessions"
              @updateTable="fetchSessions"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import AddSessionModal from '@/components/tuition/manage/session/Add'
import TuitionSessionTable from '@/components/tuition/manage/session/Table'

export default {
  name: 'TuitionSessionView',
  components: {
    AddSessionModal,
    TuitionSessionTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-session', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loadingPrograms: false,
      loadingSessions: false,
      programs: [],
      selectedProgramId: undefined,
      data: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  computed: {
    programOptions() {
      return this.programs.map(p => ({
        label: p.name + (p.code ? ` (${p.code})` : ''),
        value: p.id,
      }))
    },
  },
  mounted() {
    this.fetchPrograms()
  },
  methods: {
    fetchPrograms() {
      this.loadingPrograms = true
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.programs = data.data || data
        })
        .finally(() => {
          this.loadingPrograms = false
        })
    },
    fetchSessions() {
      if (!this.selectedProgramId) return

      this.loadingSessions = true
      this.$http.get(`/api/tuition/programs/${this.selectedProgramId}/sessions`)
        .then(({ data }) => {
          this.data = data.data || data
        })
        .finally(() => {
          this.loadingSessions = false
        })
    },
    filterProgramOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>
